function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import _ from 'underscore';
import HSPOverview from './kablammo';
import _downloadFASTA from './download_fasta';
import AlignmentExporter from './alignment_exporter'; // to download textual alignment
import HitButtons from 'hit_buttons';

/**
 * Component for each hit. Receives props from Report. Has no state.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var _default = /*#__PURE__*/function (_Component) {
  function _default(props) {
    var _this;
    _classCallCheck(this, _default);
    _this = _callSuper(this, _default, [props]);
    _this.accession = _this.accession.bind(_this);
    _this.sequenceID = _this.sequenceID.bind(_this);
    _this.hitLength = _this.hitLength.bind(_this);
    _this.numHSPs = _this.numHSPs.bind(_this);
    _this.domID = _this.domID.bind(_this);
    _this.databaseIDs = _this.databaseIDs.bind(_this);
    _this.showSequenceViewer = _this.showSequenceViewer.bind(_this);
    _this.viewSequenceLink = _this.viewSequenceLink.bind(_this);
    _this.downloadFASTA = _this.downloadFASTA.bind(_this);
    _this.downloadAlignment = _this.downloadAlignment.bind(_this);
    _this.headerJSX = _this.headerJSX.bind(_this);
    _this.contentJSX = _this.contentJSX.bind(_this);
    _this.hitLinks = _this.hitLinks.bind(_this);
    _this.viewSequenceButton = _this.viewSequenceButton.bind(_this);
    _this.downloadFASTAButton = _this.downloadFASTAButton.bind(_this);
    _this.hit_buttons = new HitButtons(_this);
    return _this;
  }
  _inherits(_default, _Component);
  return _createClass(_default, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !this.props.hit;
    }
    /**
     * Returns accession number of the hit sequence.
     */
  }, {
    key: "accession",
    value: function accession() {
      return this.props.hit.accession;
    }

    /**
     * Returns id of the hit sequence.
     */
  }, {
    key: "sequenceID",
    value: function sequenceID() {
      return this.props.hit.id;
    }

    /**
     * Returns length of the hit sequence.
     */
  }, {
    key: "hitLength",
    value: function hitLength() {
      return this.props.hit.length;
    }
  }, {
    key: "numHSPs",
    value: function numHSPs() {
      return this.props.hit.hsps.length;
    }

    // Internal helpers. //

    /**
     * Returns id that will be used for the DOM node corresponding to the hit.
     */
  }, {
    key: "domID",
    value: function domID() {
      return 'Query_' + this.props.query.number + '_hit_' + this.props.hit.number;
    }
  }, {
    key: "databaseIDs",
    value: function databaseIDs() {
      return _.map(this.props.querydb, _.iteratee('id'));
    }
  }, {
    key: "showSequenceViewer",
    value: function showSequenceViewer() {
      this.props.showSequenceModal(this.viewSequenceLink());
    }
  }, {
    key: "viewSequenceLink",
    value: function viewSequenceLink() {
      var sequenceIDs = encodeURIComponent(this.sequenceID());
      var databaseIDs = encodeURIComponent(this.databaseIDs());
      return "get_sequence/?sequence_ids=".concat(sequenceIDs, "&database_ids=").concat(databaseIDs);
    }
  }, {
    key: "downloadFASTA",
    value: function downloadFASTA(_event) {
      var sequenceIDs = [this.sequenceID()];
      _downloadFASTA(sequenceIDs, this.databaseIDs());
    }

    // Event-handler for exporting alignments.
    // Calls relevant method on AlignmentExporter defined in alignment_exporter.js.
  }, {
    key: "downloadAlignment",
    value: function downloadAlignment(_event) {
      var hsps = _.map(this.props.hit.hsps, _.bind(function (hsp) {
        hsp.query_id = this.props.query.id;
        hsp.hit_id = this.props.hit.id;
        return hsp;
      }, this));
      var aln_exporter = new AlignmentExporter();
      aln_exporter.export_alignments(hsps, this.props.query.id + '_' + this.props.hit.id);
    }
  }, {
    key: "headerJSX",
    value: function headerJSX() {
      var meta = "Length: ".concat(this.hitLength().toLocaleString());
      if (this.props.showQueryCrumbs && this.props.showHitCrumbs) {
        // Multiper queries, multiple hits
        meta = "hit ".concat(this.props.hit.number, " of query ").concat(this.props.query.number, ". ").concat(meta);
      } else if (this.props.showQueryCrumbs && !this.props.showHitCrumbs) {
        // Multiple queries, single hit
        meta = "the only hit of query ".concat(this.props.query.number, ". ").concat(meta);
      } else if (!this.props.showQueryCrumbs && this.props.showHitCrumbs) {
        // Single query, multiple hits
        meta = "hit ".concat(this.props.hit.number, ". ").concat(meta);
      }
      return /*#__PURE__*/_jsxs("div", {
        className: "section-header border-b border-seqorange flex flex-col sm:flex-row sm:justify-between w-full",
        children: [/*#__PURE__*/_jsxs("h4", {
          className: "text-sm cursor-pointer flex flex-col sm:flex-row items-start sm:items-center",
          "data-parent-id": "#".concat(this.domID()),
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("i", {
              className: "fa-regular fa-square-minus print:!hidden"
            }), /*#__PURE__*/_jsxs("strong", {
              className: "cursor-text ml-1 print:ml-0",
              children: [" ", this.props.hit.id]
            })]
          }), /*#__PURE__*/_jsx("span", {
            className: "ml-1",
            children: this.props.hit.title
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: "label first-letter:capitalize text-sm font-normal text-inherit cursor-text",
          children: meta
        })]
      });
    }
  }, {
    key: "contentJSX",
    value: function contentJSX() {
      return /*#__PURE__*/_jsxs("div", {
        className: "pt-0 px-0 pb-px",
        "data-parent-hit": this.domID(),
        children: [this.hitLinks(), /*#__PURE__*/_jsx(HSPOverview, {
          query: this.props.query,
          hit: this.props.hit,
          algorithm: this.props.algorithm,
          showHSPCrumbs: this.numHSPs() > 1 && this.numHSPs() < 27,
          collapsed: this.props.veryBig
        }, 'kablammo' + this.props.query.id)]
      });
    }
  }, {
    key: "hitLinks",
    value: function hitLinks() {
      var _this2 = this;
      var btns = [];
      if (!(this.props.imported_xml || this.props.non_parse_seqids)) {
        btns = btns.concat([this.viewSequenceButton(), this.downloadFASTAButton()]);
      }
      btns.push(this.downloadAlignmentButton());
      this.hit_buttons.buttons().forEach(function (button) {
        btns.push(button);
      });
      return /*#__PURE__*/_jsxs("div", {
        className: "hit-links h-4 print:hidden",
        children: [/*#__PURE__*/_jsxs("label", {
          className: "text-sm text-seqblue hover:seqorange cursor-pointer mb-0",
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            id: this.domID() + '_checkbox',
            value: this.sequenceID(),
            onChange: function () {
              this.props.selectHit(this.domID() + '_checkbox');
              this.props.onChange();
            }.bind(this),
            "data-target": '#' + this.domID()
          }), " Select"]
        }), btns.map(function (btn, index) {
          return [/*#__PURE__*/_jsx("span", {
            className: "text-seqorange mt-0 mr-1 ml-0 mb-1 px-1",
            children: "|"
          }, "btn-".concat(index)), _this2.button(Object.assign(btn, {
            key: index
          }))];
        }), this.props.hit.links.map(function (link, index) {
          return [/*#__PURE__*/_jsx("span", {
            className: "text-seqorange mt-0 mr-1 ml-0 mb-1 px-1",
            children: "|"
          }, "link-".concat(index)), _this2.a(link, index)];
        })]
      });
    }

    // Return JSX for view sequence button.
  }, {
    key: "viewSequenceButton",
    value: function viewSequenceButton() {
      var _this3 = this;
      if (this.hitLength() > 10000) {
        return {
          text: 'Sequence',
          icon: 'fa-eye',
          className: 'view-sequence',
          title: 'Sequence too long'
        };
      } else {
        return {
          text: 'Sequence',
          icon: 'fa-eye',
          className: 'view-sequence',
          onClick: function onClick() {
            return _this3.showSequenceViewer();
          }
        };
      }
    }
  }, {
    key: "downloadFASTAButton",
    value: function downloadFASTAButton() {
      var _this4 = this;
      return {
        text: 'FASTA',
        icon: 'fa-download',
        className: 'download-fa',
        onClick: function onClick() {
          return _this4.downloadFASTA();
        }
      };
    }
  }, {
    key: "downloadAlignmentButton",
    value: function downloadAlignmentButton() {
      var _this5 = this;
      return {
        text: 'Alignment',
        icon: 'fa-download',
        className: 'download-aln',
        onClick: function onClick() {
          return _this5.downloadAlignment();
        }
      };
    }
  }, {
    key: "button",
    value: function button(_ref) {
      var text = _ref.text,
        icon = _ref.icon,
        title = _ref.title,
        className = _ref.className,
        onClick = _ref.onClick,
        key = _ref.key;
      if (onClick) {
        return /*#__PURE__*/_jsxs("button", {
          className: "btn-link text-sm text-seqblue hover:text-seqorange cursor-pointer ".concat(className),
          title: title,
          onClick: onClick,
          children: [/*#__PURE__*/_jsx("i", {
            className: "fa ".concat(icon)
          }), " ", text]
        }, key);
      } else {
        return /*#__PURE__*/_jsxs("button", {
          className: "text-sm view-sequence disabled",
          title: title,
          disabled: true,
          children: [/*#__PURE__*/_jsx("i", {
            className: "fa ".concat(icon)
          }), " ", text]
        }, key);
      }
    }

    /**
     * Render URL for sequence-viewer.
     */
  }, {
    key: "a",
    value: function a(link, key) {
      if (!link.title || !link.url) return;
      var className = 'btn-link text-sm text-seqblue hover:text-seqorange cursor-pointer';
      if (link["class"]) className = "".concat(className, " ").concat(link["class"]);
      return /*#__PURE__*/_jsxs("a", {
        href: link.url,
        className: className,
        target: "_blank",
        children: [link.icon && /*#__PURE__*/_jsx("i", {
          className: 'fa ' + link.icon
        }), ' ' + link.title + ' ']
      }, "".concat(link.url, "-").concat(key));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        className: "hit mt-1 border-l-2 border-transparent pl-1 -ml-1",
        id: this.domID(),
        "data-hit-def": this.props.hit.id,
        "data-hit-len": this.props.hit.length,
        "data-hit-evalue": this.props.hit.evalue,
        children: [this.headerJSX(), " ", this.contentJSX()]
      });
    }
  }]);
}(Component);
export { _default as default };